import { omit } from 'lodash';
import * as types from '../constants/action-types';
const toastInitialState = {
    items: {},
    ids: [],
};
export const toastReducer = (state = toastInitialState, action) => {
    switch (action.type) {
        case types.ADD_TOAST: {
            const toast = action.payload;
            return {
                ...state,
                items: { ...state.items, [toast.id]: toast },
                ids: [...state.ids, toast.id],
            };
        }
        case types.REMOVE_TOAST: {
            const id = action.payload;
            return {
                ...state,
                items: omit(state.items, id),
                ids: state.ids.filter((toastId) => toastId !== id),
            };
        }
        case types.RESET: {
            return toastInitialState;
        }
        default:
            return state;
    }
};
export default toastReducer;
